<mat-form-field subscriptSizing="dynamic">
    <mat-label *ngIf="label()">{{ label() }}</mat-label>
    <input
        #control
        matInput
        currencyMask
        [required]="required()"
        [ngModel]="value()"
        [options]="currencyMaskConfig"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [type]="type()"
        (blur)="onValueChanged()"
        (ngModelChange)="onNgModelChanged($event)"
        (keyup)="keyPressed($event)" />
    <mat-hint *ngIf="hint()">{{ hint() }}</mat-hint>
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
